export enum ProgramLevel {
  UNDERGRADUATE = 'UNDERGRADUATE',
  GRADUATE = 'GRADUATE',
  LIFELONG = 'LIFELONG',
}
